var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[_vm.$style.area, _vm.$style.card]},[_c('AnalyticsInsightsTable',{attrs:{"analytics":_vm.analytics,"hasTotalFans":_vm.hasTotalFans,"compact":_vm.compact}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }